<template>
  <!-- this component is for desktop -->
  <div v-if="showOfferListingWrapper">
    <generic-modal
      @close="closeOffersWrapper()"
      :height="OfferModalDim.height"
      :width="OfferModalDim.width"
      :padding="OfferModalDim.padding"
      :modalClass="OfferModalDim.modalClass"
      overflowNotNeeded="true"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <offer-listing-page />
      </template>
      <template v-slot:footer> </template>
    </generic-modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import {
  keyMapsAction,
  keyMapsGetter,
  keyMapsMutation,
} from "../helpers/storeKeys";

export default {
  name: "OfferListingWrapper",
  components: {
    "offer-listing-page": defineAsyncComponent(() =>
      import("./OffersListingPage.vue")
    ),
  },
  // props: ['dataResults'],
  data() {
    return {
      OfferModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "wrapper-offer-modal full-screen-popup  lg-screen-centered",
      },
    };
  },
  methods: {
    closeOffersWrapper() {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_INIT_OFFER_LISTING_WRAPPER,
        false
      );
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER, {});
    },
  },
  computed: {
    showOfferListingWrapper() {
      return this.$store.state.Offers.initOfferListingWrapper;
    },
  },
};
</script>
